/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.#injectProductCard();
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  #injectProductCard() {
    const mode = this.dataset.injectMode;
    const templateId = this.dataset.productCardTemplate;
    if (!mode || !templateId) return;
    const template = document.getElementById(templateId);
    if (!template) return;

    if (mode === 'keyword') {
      const keyword = (this.dataset.injectKeyword || '').toLowerCase();
      this.#injectAfterKeyword(keyword, template);
    } else {
      this.#injectAtCharDepth(Number(this.dataset.injectThreshold || 20), template);
    }
  }

  #injectAfterKeyword(keyword, template) {
    if (!keyword) {
      this.#injectAtCharDepth(20, template);
      return;
    }
    for (const p of this.querySelectorAll('p')) {
      if (p.textContent.toLowerCase().includes(keyword)) {
        p.after(template.content.cloneNode(true));
        console.debug(`[blog-inject] mode=keyword keyword="${keyword}"`);
        return;
      }
    }
    // keyword not found in rendered DOM — fall back to char depth
    this.#injectAtCharDepth(20, template);
  }

  #injectAtCharDepth(percent, template) {
    const paragraphs = [...this.querySelectorAll('p')];
    const total = paragraphs.reduce((sum, p) => sum + p.textContent.length, 0);
    const target = total * (percent / 100);
    let acc = 0;
    for (const p of paragraphs) {
      acc += p.textContent.length;
      if (acc >= target) {
        p.after(template.content.cloneNode(true));
        console.debug(`[blog-inject] mode=scroll depth=${percent}%`);
        return;
      }
    }
    // fewer paragraphs than expected — append at end
    if (paragraphs.length > 0) {
      paragraphs[paragraphs.length - 1].after(template.content.cloneNode(true));
      console.debug(`[blog-inject] mode=scroll depth=${percent}% (appended at end)`);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
